<template>
  <div class="content content--quiz">
    <OverlayLoader v-if="!$store.getters.quizzesLoaded"></OverlayLoader>
    <div class="bg-img">
      <img src="../../assets/images/hero-quiz.jpg">
    </div>

    <MyHeader :breadcrumbItems="
      [

        {
          name: section.name,
          path: `/${$route.params.companySlug}/quizzes`
        }
      ]"/>

    <header class="content-header">
      <h1>{{section.name}}</h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <div class="tabs-vertical">
          <ul class="tabs-inner">
            <li>
              <router-link active-class="active" exact :to="{name: 'QuizList'}">
                Ongoing {{section.name}}
                <i class="icon-arrow"></i>
              </router-link>
            </li>
            <li>
              <router-link active-class="active" :to="{name: 'LeaderboardList'}">
                Leaderboard
                <i class="icon-arrow"></i>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </transition>

    <div class="container main-content--tabbed">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <div class="tabs-vertical">
            <ul class="tabs-inner">
              <li>
                <router-link active-class="active" exact :to="{name: 'QuizList'}">
                  Ongoing {{section.name}}
                  <i class="icon-arrow"></i>
                </router-link>
              </li>
              <li>
                <router-link active-class="active" :to="{name: 'LeaderboardList'}">
                  Leaderboard
                  <i class="icon-arrow"></i>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import OverlayLoader from "@/components/general/OverlayLoader";

export default {
  name: "Quiz",
  components: {OverlayLoader, MyHeader},
  data () {
    return {
      showList: false,
    }
  },
  mounted() {
    this.$store.dispatch('getQuizzes')
    this.$store.dispatch('getLeaderboards')
  },
  computed: {
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'QuizIndex'
      })
    },
  },
}
</script>
